import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiDocumentServiceRepository } from '../../services/repositories/implementations/ApiDocumentServiceRepository';
import { trackError } from '@proposify/frontend-observability';
import type { ContactsControllerCreateContactMutationRequest } from '@proposify/document-service-api-client';
import { FeatureFlags } from 'utils/featureFlags';
import { ApiCompanyAndContactsRepository } from 'services/company-and-contacts/ApiCompanyAndContactsRepository';
import useFeatureFlag from 'hooks/useFeatureFlag';

export const useCreateContact = () => {
  const queryClient = useQueryClient();
  const featureFlags = useFeatureFlag([FeatureFlags.useVariablesBff]);
  const isUseVariablesBffFlagEnabled = featureFlags[FeatureFlags.useVariablesBff];
  const repository = isUseVariablesBffFlagEnabled ? ApiCompanyAndContactsRepository : apiDocumentServiceRepository;

  return useMutation({
    mutationFn: async (contactData: ContactsControllerCreateContactMutationRequest) => {
      const documentServiceResult = await repository.createContact(contactData);

      if (!documentServiceResult.lastName) {
        trackError(documentServiceResult, {
          action: 'createContact',
          repository: isUseVariablesBffFlagEnabled ? 'ApiCompanyAndContactsRepository' : 'ApiDocumentServiceRepository',
        });
      }

      return documentServiceResult;
    },
    onSuccess: (_result, variables) => {
      variables.companies?.forEach((company) => {
        queryClient.invalidateQueries({ queryKey: ['company-contacts', company.id] });
      });

      queryClient.invalidateQueries({ queryKey: ['contacts'] });
    },
  });
};
